var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"device-wrapper"},[_c('section',{staticClass:"device-list-wrapper"},[_c('device-list')],1),_vm._v(" "),_c('section',{staticClass:"device-factor-wrapper"},[_c('device-factor'),_vm._v(" "),_c('device-status')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-111c326f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/09System-Settings/04Config/03Device/index.vue
// module id = null
// module chunks = 